module.exports = __webpack_public_path__ + "img/back_blue_03.45954b61.jpg";